import { useStore } from "../context/StoreContext";

const Footer = () => {
  const { t } = useStore();
  return (
    <footer className="border-t border-[var(--line)] bg-[var(--ink)] text-white" data-testid="footer">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-4 py-10 sm:flex-row sm:items-end sm:justify-between sm:px-6">
        <div>
          <img src="/images/logo-light.png" alt="MKB Performance" className="h-12 w-auto" data-testid="footer-logo" />
          <p className="mt-3 text-sm text-white/60">ZENKAI Pre-Workout</p>
        </div>
        <div className="text-sm text-white/70">
          <p className="text-xs font-semibold uppercase tracking-wider text-white/50">{t.footer.contact}</p>
          <a href={`mailto:${t.footer.email}`} className="hover:text-white" data-testid="footer-email">{t.footer.email}</a>
          <a href="/admin/berichten" className="ml-3 text-xs text-white/40 hover:text-white" data-testid="footer-admin-link">Beheer</a>
          <p className="mt-3 text-xs text-white/50">{t.footer.legal}</p>
          <p className="mt-1 text-xs text-white/50" data-testid="footer-rights">{t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
